import { connect } from 'react-redux'
import editorSelector from './editorSelector'
import {
  add as addUnsavedChange,
  remove as removeUnsavedChange
} from 'store/redux/unsavedChanges'
import Editor from './Editor'

export default connect(
  editorSelector,
  {
    addUnsavedChange,
    removeUnsavedChange
  },
  null,
  {
    forwardRef: true
  }
)(Editor)
